var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send",
    clipPath: "url(#clip0_1729_9191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.99952 9.00012L13.9995 2.00012M7.08457 9.21883L8.83665 13.7242C8.991 14.1211 9.06817 14.3195 9.17937 14.3774C9.27577 14.4277 9.39061 14.4277 9.48706 14.3776C9.59833 14.3198 9.67574 14.1215 9.83056 13.7247L14.2241 2.46625C14.3639 2.10813 14.4337 1.92907 14.3955 1.81465C14.3623 1.71528 14.2844 1.6373 14.185 1.60411C14.0706 1.56588 13.8915 1.63576 13.5334 1.77552L2.27489 6.16908C1.87817 6.32389 1.67981 6.4013 1.62201 6.51257C1.5719 6.60903 1.57196 6.72386 1.62219 6.82026C1.68013 6.93146 1.87858 7.00864 2.27547 7.16299L6.78081 8.91506C6.86137 8.94639 6.90166 8.96206 6.93558 8.98625C6.96564 9.0077 6.99193 9.03399 7.01338 9.06406C7.03758 9.09798 7.05324 9.13826 7.08457 9.21883Z",
    stroke: "#7E7E7E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1729_9191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.9d017659bc0a3fa560ff3a82101eb182.svg";
export { ForwardRef as ReactComponent };